import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=0128513c"
import script from "./Debt.vue?vue&type=script&lang=js"
export * from "./Debt.vue?vue&type=script&lang=js"
import style0 from "./Debt.vue?vue&type=style&index=0&id=0128513c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports